import { render, staticRenderFns } from "./OsLoadingIndicator.vue?vue&type=template&id=7dbfb0f8&scoped=true"
import script from "./OsLoadingIndicator.vue?vue&type=script&lang=ts"
export * from "./OsLoadingIndicator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbfb0f8",
  null
  
)

export default component.exports